import { Component, Input, OnInit } from '@angular/core';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { UsuarioViewModel } from '../../usuarios/usuarios.types';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { RegLaboratorioService } from './laboratorio.service';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { RegLaboratorioViewModel, RegTecnicoLaboratorioViewModel } from './laboratorio.types';
import { CustomValidator } from '../../../core/_infrastructure/classes/customValidator';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';

@Component({
    selector: 'app-tecnicolaboratorio-edit',
    templateUrl: '/tecnicolaboratorio-edit.component.html',
})
export class TecnicoLaboratorioEditComponent extends ComponentBase implements OnInit {
    editMode: boolean;
    editTitle = 'Nuevo';
    usuarioTecnicoLaboratorio: UsuarioViewModel;
    IdLaboratorio: number;
    visibilitySpinner = false;
    isCollapsedLaboratorio = false;
    razonSocial = '';
    laboratorio: RegLaboratorioViewModel;

    constructor(
        public activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: FormBuilder,
        protected notificationService: NotificationService,
        private laboratorioService: RegLaboratorioService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);

        this.usuarioTecnicoLaboratorio = new UsuarioViewModel();
        this.usuarioTecnicoLaboratorio.TwRegTecnicoLaboratorio = new RegTecnicoLaboratorioViewModel();
        this.usuarioTecnicoLaboratorio.TwRegLaboratorio = new RegLaboratorioViewModel();
    }

    ngOnInit() {
        this.createForm();

        this.IdLaboratorio = +this.activatedRoute.snapshot.params['id'];
        let idTecnico = +this.activatedRoute.snapshot.params['idTecnico'];

        this.laboratorioService.getLaboratorio(this.IdLaboratorio).subscribe(res => {
            if (!res) {
                return;
            }
            this.laboratorio = res;
            this.razonSocial = res.RazonSocial;
            this.processTecnicoData(idTecnico);
        });
    }

    private processTecnicoData(idTecnico: number): void {
        //Edit
        if (idTecnico) {
            this.editMode = true;
            this.editTitle = 'Editar';

            this.laboratorioService.getTecnico(idTecnico).subscribe(result => {
                this.usuarioTecnicoLaboratorio = result;
                this.updateForm();
            });

            //En edición se deshabilita para no poder modificar el NIF
            this.form.controls['Nif'].disable();

            //Si el laboratorio está inactivo el técnico estará inactivo y no podrá modificarse
            if (!this.laboratorio.Activo) {
                this.form.controls['Activo'].disable();
                this.form.patchValue({
                    Activo: false,
                });
            }
        }
        //Alta
        else {
            this.form.patchValue({ Laboratorio: this.razonSocial });
            //En el alta se graba Activo por defecto
            this.form.controls['Activo'].disable();

            //Si el laboratorio está inactivo el técnico se graba como inactivo por defecto
            if (!this.laboratorio.Activo) {
                this.form.controls['Activo'].disable();
                this.form.patchValue({
                    Activo: false,
                });
            }
        }
    }

    private createForm() {
        this.form = this.fb.group({
            Laboratorio: ['', Validators.required],
            Nif: ['', Validators.compose([Validators.required, CustomValidator.NIFValidator])],
            NombreUsuario: ['', Validators.required],
            ApellidosUsuario: ['', Validators.required],
            Email: ['', Validators.compose([Validators.required, CustomValidator.emailEmptyValidator])],
            Telefono: ['', Validators.required],
            Activo: true,
            FechaCreacion: [{ value: '', disabled: true }],
            FechaActivacion: [{ value: '', disabled: true }],
            FechaBaja: [{ value: '', disabled: true }],
        });
    }

    private updateForm() {
        this.form.setValue({
            Laboratorio: this.razonSocial,
            Nif: this.usuarioTecnicoLaboratorio.Nif,
            NombreUsuario: this.usuarioTecnicoLaboratorio.Nombre,
            ApellidosUsuario: this.usuarioTecnicoLaboratorio.Apellidos,
            Email: this.usuarioTecnicoLaboratorio.Email,
            Telefono: this.usuarioTecnicoLaboratorio.TwRegTecnicoLaboratorio.Telefono,
            Activo: this.usuarioTecnicoLaboratorio.Activo,
            FechaCreacion: new Date(this.usuarioTecnicoLaboratorio.FechaCreacion),
            FechaActivacion: this.usuarioTecnicoLaboratorio.FechaActivacion != null ? new Date(this.usuarioTecnicoLaboratorio.FechaActivacion) : '',
            FechaBaja: this.usuarioTecnicoLaboratorio.FechaBaja != null ? new Date(this.usuarioTecnicoLaboratorio.FechaBaja) : '',
        });
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos');
            this.isCollapsedLaboratorio = false;
            return;
        }

        this.visibilitySpinner = true;

        this.createUsuarioTecnicoLaboratorio();
        this.editUsuarioTecnicoLaboratorio();
    }

    private usuarioTecnicoLaboratorioData(usuarioTecnicoLaboratorio: UsuarioViewModel) {
        //usuarioTecnicoLaboratorio.TwRegLaboratorio.RazonSocial = this.form.value.Laboratorio;
        usuarioTecnicoLaboratorio.Nif = this.form.value.Nif != null ? this.form.value.Nif : this.usuarioTecnicoLaboratorio.Nif;
        usuarioTecnicoLaboratorio.Nombre = this.form.value.NombreUsuario;
        usuarioTecnicoLaboratorio.Apellidos = this.form.value.ApellidosUsuario;
        usuarioTecnicoLaboratorio.Email = this.form.value.Email != null ? this.form.value.Email : this.usuarioTecnicoLaboratorio.Email;
        usuarioTecnicoLaboratorio.TwRegTecnicoLaboratorio.Telefono = this.form.value.Telefono;
        usuarioTecnicoLaboratorio.Activo = this.form.value.Activo;
        usuarioTecnicoLaboratorio.TwRegTecnicoLaboratorio.IdRegLaboratorio = this.IdLaboratorio;
        usuarioTecnicoLaboratorio.Id = this.usuarioTecnicoLaboratorio.Id;

        //Perfiles
        usuarioTecnicoLaboratorio.TUsuarioPerfilCollection = this.usuarioTecnicoLaboratorio.TUsuarioPerfilCollection;
    }

    private createUsuarioTecnicoLaboratorio() {
        let usuarioTecnicoLaboratorio = new UsuarioViewModel();
        usuarioTecnicoLaboratorio.TwRegTecnicoLaboratorio = new RegTecnicoLaboratorioViewModel();
        //usuarioTecnicoLaboratorio.TwRegLaboratorio = new RegLaboratorioViewModel();

        this.usuarioTecnicoLaboratorioData(usuarioTecnicoLaboratorio);

        if (!this.editMode) {
            this.laboratorioService.addTecnico(usuarioTecnicoLaboratorio).subscribe({
                next: () => {
                    this.addSuccessMessage('Técnico autorizado creado correctamente');
                    this.visibilitySpinner = false;
                    this.onBack();
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
    }

    private editUsuarioTecnicoLaboratorio() {
        let usuarioTecnicoLaboratorio = new UsuarioViewModel();
        usuarioTecnicoLaboratorio.TwRegTecnicoLaboratorio = new RegTecnicoLaboratorioViewModel();
        //usuarioTecnicoLaboratorio.TwRegLaboratorio = new RegLaboratorioViewModel();

        usuarioTecnicoLaboratorio.FechaCreacion = this.usuarioTecnicoLaboratorio.FechaCreacion;

        this.usuarioTecnicoLaboratorioData(usuarioTecnicoLaboratorio);

        //Perfiles
        usuarioTecnicoLaboratorio.TUsuarioPerfilCollection = this.usuarioTecnicoLaboratorio.TUsuarioPerfilCollection;

        if (this.editMode) {
            this.laboratorioService.editTecnico(usuarioTecnicoLaboratorio).subscribe({
                next: () => {
                    this.addSuccessMessage('Técnico autorizado modificado correctamente');
                    this.visibilitySpinner = false;
                    this.isCollapsedLaboratorio = false;
                    this.onBack();
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.isCollapsedLaboratorio = false;
                },
            });
        }
    }

    onBack() {
        this.router.navigate(['/mantenimiento/registros/laboratorios/edit', this.IdLaboratorio]);
    }
}
